import React from 'react';
import { motion } from 'framer-motion';
interface ChapterCardProps {
  number: number;
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
}
export function ChapterCard({
  number,
  title,
  subtitle,
  children,
  className = ''
}: ChapterCardProps) {
  return <section className={`py-16 px-4 md:px-8 relative overflow-hidden ${className}`} data-id="element-25">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-12 text-center" data-id="element-27">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-[#d4a843] text-[#d4a843] font-serif text-xl mb-4 bg-[#0a1628]/50 backdrop-blur-sm shadow-[0_0_15px_rgba(212,168,67,0.2)]" data-id="element-28">
            {number}
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3 tracking-wide" data-id="element-29">
            {title}
          </h2>
          {subtitle && <p className="text-[#d4a843] text-lg md:text-xl font-light italic" data-id="element-30">
              {subtitle}
            </p>}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-31">
          {children}
        </motion.div>
      </div>
    </section>;
}